<span *ngIf="formData.form.errors">{{ formData.form.errors['error'] }}</span>
<app-form-fields-sub [fields]="formData.fields" [model]="formData.model" [group]="formData.form"></app-form-fields-sub>
